import { useEffect } from "react";

const SITE = "Enhancing Your World";

export const stripHtml = (html = "", limit = 160) => {
  const t = String(html).replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim();
  return t.length > limit ? `${t.slice(0, limit).trimEnd()}…` : t;
};

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!content) {
    if (el && el.dataset.seo) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    el.dataset.seo = "1";
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

// Per-page SEO: title, meta description, canonical, Open Graph / Twitter cards
// and optional JSON-LD structured data. Rendered client-side (Google executes JS);
// non-JS social crawlers get the same tags from the /api/share/* endpoints.
export default function Seo({ title = "", description = "", image = "", path = "", type = "website", jsonLd = null, noindex = false }) {
  const ldKey = jsonLd ? JSON.stringify(jsonLd) : "";
  useEffect(() => {
    const full = title ? `${title} — ${SITE}` : SITE;
    const url = `${window.location.origin}${path || window.location.pathname}`;
    document.title = full;
    setMeta("name", "description", description);
    setMeta("property", "og:site_name", SITE);
    setMeta("property", "og:type", type);
    setMeta("property", "og:title", full);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", url);
    setMeta("property", "og:image", image);
    setMeta("name", "twitter:card", image ? "summary_large_image" : "summary");
    setMeta("name", "twitter:title", full);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", image);
    let canon = document.head.querySelector('link[rel="canonical"]');
    if (!canon) {
      canon = document.createElement("link");
      canon.rel = "canonical";
      document.head.appendChild(canon);
    }
    canon.href = url;
    let script = null;
    if (ldKey) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.text = ldKey;
      document.head.appendChild(script);
    }
    return () => {
      if (script) script.remove();
      document.title = SITE;
    };
  }, [title, description, image, path, type, ldKey]);
  // Members-only / ticket-holder pages stay out of search results.
  useEffect(() => {
    if (!noindex) return undefined;
    const el = Object.assign(document.createElement("meta"), { name: "robots", content: "noindex, follow" });
    el.setAttribute("data-seo-noindex", "1");
    document.head.appendChild(el);
    return () => el.remove();
  }, [noindex]);
  return null;
}
